import { Box, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import type { FormikProps } from 'formik';

import InfoCard from '../../../components/info-card';
import { Payment } from '../../../components/bulk-request';
import { TestReview, AssessmentDetail, TotalSummary } from '../../../components/shared';
import { TermsAndConditions } from '../../../components/request';
import { type AddBulkRequestProps, Test } from '../../../models';
import { PaymentOptionSelector } from '../../../components/bulk-request';
import { Payment as PaymentUtils } from '../../../utils/payment';

export const BulkRequestReview = ({ formik }: { formik: FormikProps<AddBulkRequestProps> }) => {
	const { tests, location, prefAssessmentDates } = formik.values;

	const handlePaymentChange = (amount: number) => {
		if (formik.values.amount !== amount) {
			formik.setFieldValue('amount', amount);
		}
	};

	const payment = new PaymentUtils(tests);

	return (
		<Box>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12, md: 7 }}>
					<Stack spacing={3}>
						<TestReview tests={Test.removeNilTest(tests)} />
						<InfoCard title="Assessment Details">
							<AssessmentDetail assessmentDates={prefAssessmentDates} location={location} dateLineText="Preferred" />
						</InfoCard>
						<Payment>
							<PaymentOptionSelector tests={tests} onChange={handlePaymentChange} />
						</Payment>

						{formik && <TermsAndConditions formik={formik} isBulkRequest />}
					</Stack>
				</Grid>

				<Grid size={{ xs: 12, md: 5 }}>
					<TotalSummary total={payment.total()} subtotal={payment.subtotal()} gst={payment.gst()} />
				</Grid>
			</Grid>
		</Box>
	);
};
